import { ConstructorAnalytics, constructorAnalytics } from '~/src/features/tariffBuilder/analytics';
import { constructorCurrentTariffAnalytics } from '~/src/features/tariffBuilder/analytics';
import { useCtxSelector } from '~/src/features/tariffBuilder/hooks';
import selectCurrentTariff from '~/src/features/tariffBuilder/selectors/selectCurrentTariff';

export const useConstructorAnalytics = (): ConstructorAnalytics => {
    const currentTariff = useCtxSelector(state => selectCurrentTariff(state));

    if (currentTariff) {
        return constructorCurrentTariffAnalytics;
    }
    return constructorAnalytics;
};
